import { Box, Typography } from '@mui/material';
import type { ReactElement } from 'react';

import brandIcon from '@/assets/connexion/miamiam-icon-64x64.png';
import { fontWeights, radius } from '@/ui/tokens';

/**
 * Marque de l'ecran de connexion : pastille blanche, icone et mot-symbole.
 *
 * L'icone est `02-favicons-app-icons/miamiam-icon-64x64.png` (30 px, soit 2×) :
 * le recadrage du logo vertical que dessine la maquette porte un fond sombre et
 * ne se reproduit pas tel quel. Le mot-symbole est ecrit en texte, en deux
 * couleurs de jeton — `accentPinkStrong` et `accentMintStrong` — et non avec
 * les deux hexadecimaux de la maquette, qui n'atteignent que 4,5 et 4,2:1 et ne
 * suivraient pas le mode sombre. Nunito ExtraBold et non Black, graisse
 * non embarquee (ecart assume, issue #498).
 *
 * Le texte « MiaMiam » est le nom de l'application, pas une description : il
 * reste lu par les technologies d'assistance.
 */
export const BrandPill = (): ReactElement => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1,
      py: 1,
      pl: 1.25,
      pr: 2,
      borderRadius: `${String(radius.pill)}px`,
      bgcolor: 'tokens.surface',
      border: 1,
      borderColor: 'tokens.border',
    }}
  >
    <Box component="img" src={brandIcon} alt="" width={30} height={30} sx={{ display: 'block' }} />
    <Typography
      component="span"
      sx={{ fontSize: 17, fontWeight: fontWeights.extraBold, lineHeight: '22px', letterSpacing: 0 }}
    >
      <Box component="span" sx={{ color: 'tokens.accentPinkStrong' }}>
        Mia
      </Box>
      <Box component="span" sx={{ color: 'tokens.accentMintStrong' }}>
        Miam
      </Box>
    </Typography>
  </Box>
);
